export default __webpack_public_path__ + "static/media/edge.7ecd938b.svg";